import  { useState,useEffect, useRef } from 'react';


import Tooltip from '@mui/material/Tooltip';

/* CSS */
import '../styles/stepper.css'
import BackdropModal from './modals/backdrop_modal';
import SignatureModalForMobile from './SignatureModalForMobile';
import BackdropModalSignature from './modals/backdrop_modal_signature';

const ImageCapture = ({ onImageChange, title="Capture an Image", subtitle="", btnCameraTitle="Open Camera", keyName="captured-image",preLoadedImage, useSignaturePad=true,preLoadedSignature, hasUploadButton=true, hasRemoveButton=false, info="Upload" }) => {
    
    const [cameras, setCameras] = useState([]); // Store available cameras
    const [selectedCamera, setSelectedCamera] = useState(null); // Store selected camera
    const [isModalOpen, setModalOpen] = useState(false);
    
     


    // GET ALL CAMERAS
    useEffect(() => {
        navigator.mediaDevices.enumerateDevices()
            .then(devices => {
                const videoDevices = devices.filter(device => device.kind === 'videoinput');
                setCameras(videoDevices);
            })
            .catch(error => {
                console.error('Error accessing media devices:', error);
            });
    }, []);
    
    useEffect(() => {
        if (preLoadedImage) {
            if (typeof preLoadedImage === "string") {
                // It's a URL
                setPreview(preLoadedImage); // Directly use the URL as preview
                setImage(preLoadedImage);   // Set the URL as the image
                setImageName("Captured Image"); // Optionally, set a default name
            } else if (preLoadedImage instanceof File) {
                // It's a File object
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreview(reader.result); // Set the data URL as preview
                    setImage(preLoadedImage);
                    setImageName(preLoadedImage.name || "Captured Image");
                };
                reader.readAsDataURL(preLoadedImage); // Convert the file to a data URL
            }
        }
    }, [preLoadedImage]);


    useEffect(() => {
        if (preLoadedSignature) {
           setSignature(preLoadedSignature)
        }
    }, [preLoadedSignature]);


    
    

    const [image, setImage] = useState(null);
    const [imageName, setImageName] = useState('');
    const [preview, setPreview] = useState(preLoadedImage);
    const [isCameraOpen, setIsCameraOpen] = useState(false);
    const [showOpenCameraButton, setShowOpenCameraButton] = useState(true);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const fileInputRef = useRef(null);

  const [isAnimating, setIsAnimating] = useState(false);
  const playClickSound = () => {
    const clickSound = new Audio('/iusevolutione/assets/audio/camera_shutter.mp3'); // Provide path to your click sound
    clickSound.play();
  };


    const handleFileChange = (e) => {
        if (e && e.target && e.target.files && e.target.files.length > 0) {

            console.log(e);

            const file = e.target.files[0];
            setImage(file);
            setImageName(file.name);
            const fileReader = new FileReader();
            fileReader.onload = () => {
                setPreview(fileReader.result);
            };
            fileReader.readAsDataURL(file);
            setIsCameraOpen(false);
            setShowOpenCameraButton(false);

            onImageChange(file,keyName); // Notify parent component of the selected file
        }
        else {
            return
        }
    };

    const openCamera = () => {
        setIsCameraOpen(true);
        setPreview(null);
        setImageName("");
        setShowOpenCameraButton(false);

       /* navigator.mediaDevices.getUserMedia({ video: { width: 275, height: 275 } })
            .then(stream => {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
            })
            .catch(err => {
                console.error("Error accessing camera: ", err);
            });*/

            if(cameras.length > 0){
                if (!selectedCamera) {
                    setSelectedCamera(cameras[0].deviceId);
                }
           
        
          
                 const constraints = {
                    video: {
                        deviceId:  selectedCamera ? { exact: selectedCamera } : cameras[0].deviceId,
                        width: 275,
                        height: 275,
                    },
                };
        
                navigator.mediaDevices.getUserMedia(constraints)
                .then(stream => {
                    try {
                        // Ensure the videoRef exists
                        if (videoRef.current) {
                          // Set the stream to the video element
                          videoRef.current.srcObject = stream;
                
                          // Attempt to play the video
                          videoRef.current.play().catch(playError => {
                            console.error("Video play failed: ", playError);
                          });
                        }
                      } catch (error) {
                        console.error("Error setting video stream: ", error);
                      }
                    
                })
                .catch(err => {
                    console.error("Error accessing camera: ", err);
                });
        
            }
    };

    const takePicture = () => {

         // Trigger animation (e.g., blinking effect for a short period)
         setIsAnimating(true);
         setTimeout(() => {
             setIsAnimating(false);
         }, 500);

        // Play click sound
        playClickSound();

        const context = canvasRef.current.getContext('2d');
        canvasRef.current.width = 1080;
        canvasRef.current.height = 1080;
        context.drawImage(videoRef.current, 0, 0, 1080, 1080);
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());

        const dataUrl = canvasRef.current.toDataURL('image/png');
        setPreview(dataUrl);

        fetch(dataUrl)
            .then(res => res.blob())
            .then(blob => {
                const file = new File([blob], `${keyName}.png`, { type: 'image/png' });
                setImage(file);
                setImageName(file.name);

                onImageChange(file,keyName); // Notify parent component of the captured image
            });

        

       

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }

        setIsCameraOpen(false);
    };

    const retakePhoto = () => {
        setPreview(null);
        setImage(null);
        setImageName('');
        setShowOpenCameraButton(true);
        openCamera();
    };

    const removePhoto = () => {
        setPreview(null);
        setImage(null);
        setImageName('');
        onImageChange(null, keyName); // Notify parent component of the removal
    
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      };

    

    const handleButtonClick = () => {
        fileInputRef.current.click();
      };

      
    const handleCameraChange = (event) => {
        setSelectedCamera(event.target.value);
    };

 
      const openModal = () => {
        setModalOpen(true);
      };
    
      const closeModal = () => {
        setModalOpen(false);
      };

    useEffect(() => {
        if (selectedCamera) {
            openCamera();
        }
    }, [selectedCamera]);

    const [signature, setSignature] = useState(null);
    const handleSaveSignature = (dataURL) => {
        setSignature(dataURL);
        onImageChange(dataURL,`${keyName}Signature`);
      };

    return (

        <>


            <input
                className="btn btn-info d-none"
                name="image"
                type="file"
                onChange={handleFileChange}
                ref={fileInputRef}
            />



      
            <div className="card-body p-0 position-relative pb-0">

                {isCameraOpen && (
                    <div className="card-img card-img-right bg-label-info d-flex position-relative justify-content-center">
                        <div className="card w-100">


                            {preview ?
                                <span className="card-title d-flex position-absolute mt-2 ms-2 text-white bg-dark p-1 rounded">Captured Image</span>
                                :
                                <span className="card-title d-flex position-absolute mt-2 ms-2 text-white bg-danger p-1 rounded blinking">
                                    <i className="bx bxs-camera fs-3"></i>
                                </span>
                            }

                            <video ref={videoRef} className='rounded-top w-100'      ></video>
                            <canvas ref={canvasRef} style={{ display: 'none' }} width="275" height="275" className='justify-content-end'></canvas>

                        </div>
                    </div>
                )}


                {isCameraOpen && cameras.length > 0 && (
                    <div className="col-12 text-center mb-2">
                        <select className="form-control rounded-0 rounded-bottom" onChange={handleCameraChange} value={selectedCamera}>
                            {cameras.map((camera) => {
                                const cameraName = camera.label.replace(/\s?\(.*\)/, '');

                                return (<option key={camera.deviceId} value={camera.deviceId}>
                                    {cameraName || camera.label || `Camera ${camera.deviceId}`}
                                </option>)
                            }
                            )}
                        </select>
                    </div>
                )}


                {preview && (
                    <div className={`card-img card-img-right bg-label-info mb-1 d-flex position-relative justify-content-center ${isAnimating ? 'camera-blinking' : ''}`}>
                        <div className="card w-100">
                            <span className="card-title d-flex position-absolute mt-2 ms-2 text-white bg-dark p-1 rounded">Captured Image</span>
                            <img className="card-img-top rounded-top w-100 bg-dark" src={preview} alt="Preview" style={{ minWidth: "33%", height: "auto", objectFit: "contain" }} />

                        </div>
                    </div>
                )}

                {!preview && !isCameraOpen && (
                    <div className={`card-img rounded-3 mb-2 d-flex flex-column align-items-center justify-content-center border border-dashed border-2 w-100`} style={{ height: 275 }}>
                        <h4 className='w-100 text-center'>{info}</h4>
                        <i className='bx fs-1 bxs-image'></i>
                    </div>
                )}


                <div className="position-absolute  ms-2 rounded bg-primary p-2" style={{ zIndex: 10, marginTop: !preview && !isCameraOpen ? -50 : preview ? -50 : -90 }}>
                    <h5 className="m-0 text-white">{title}</h5>
                    {/* <p className="m-0"><span className="fw-medium">{subtitle}</span></p> */}
                </div>







             



                <div className="btn-group w-100 gap-1" role="group" >
                    {hasUploadButton &&
                        <button type="button" className="btn btn-primary" onClick={handleButtonClick}>Upload</button>
                    }
                    {!isCameraOpen && !preview && (
                        <button type="button" className="btn btn-primary" onClick={openCamera}>{btnCameraTitle}</button>
                    )}

                    {isCameraOpen && (
                        <button type="button" className="btn btn-primary" onClick={takePicture}>Take a Photo</button>
                    )}

                    {preview && (
                        <>
                            <button type="button" className="btn btn-info" onClick={retakePhoto}>Retake</button>
                            {hasRemoveButton &&
                                <button type="button" className="btn btn-danger" onClick={removePhoto}>Remove</button>
                            }
                        </>
                    )}
                </div>


               
                


                {useSignaturePad && (
                    <div className=''>
                        {!signature &&
                            <div className="card-img rounded-3 my-2 d-flex flex-column align-items-center justify-content-center border  w-100" style={{ height: 100 }}>
                                {/* <h4 className="w-100 text-center">To add a signature, click the pencil icon.</h4> */}
                            </div>
                        }

                        <div className="card-body p-0 pb-2 mt-2 position-relative">
                            {signature && <img className=' border rounded-3 w-100 mb-2' src={signature} alt="Signature" height={175} />}
                            <BackdropModalSignature size={"xl"} open={isModalOpen} handleClose={closeModal} modalTitle="Signature" hasCloseButtonBelow={false} fullScreen={true}>
                                <SignatureModalForMobile  isOpen={isModalOpen} onClose={closeModal} onSaveSignature={handleSaveSignature} />
                            </BackdropModalSignature>

                            {/* <div className="position-absolute " style={{ zIndex: 10, marginTop: !preview && !isCameraOpen ? -50 : preview ? -50 : -90 }}> */}
                           
                                <div className='d-flex flex-row'>
                                    <h5 className="text-white rounded bg-label-primary   p-2 h-100 ">Signature</h5>



                                    <Tooltip title="Click to Sign" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
                                        <button className="btn btn-label-primary h-100 ms-2" type="button" onClick={openModal} >
                                            {/* {signature ? 'Edit Signature' : 'Add Signature'} */}
                                            <i className='bx bxs-edit-alt'></i>
                                        </button>
                                    </Tooltip>
                              

                                </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ImageCapture;
